// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"Video_videoWrapper__1b4v1","mediaPlayIcon":"Video_mediaPlayIcon__TNeDy"};